import { render, staticRenderFns } from "./PedidosMainList.vue?vue&type=template&id=5882764d&scoped=true&"
import script from "./PedidosMainList.vue?vue&type=script&lang=js&"
export * from "./PedidosMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882764d",
  null
  
)

export default component.exports